export type Type = {
	scalingFactor: boolean;
	calories: boolean;
	characteristic: boolean;
	density: boolean;
	unitWeights: boolean;
	tags: boolean;
	allergen: boolean;
	season: boolean;
	co2: boolean;
};

export function create(): Type {
	return {
		scalingFactor: true,
		calories: true,
		characteristic: true,
		density: true,
		unitWeights: true,
		tags: true,
		allergen: true,
		season: true,
		co2: true,
	};
}

export function lock(obj: Type, key: keyof Type): Type {
	return { ...obj, [key]: true };
}

export function unlock(obj: Type, key: keyof Type): Type {
	return { ...obj, [key]: false };
}

export function toggle(obj: Type, key: keyof Type): Type {
	return { ...obj, [key]: !obj[key] };
}
